import { MantineThemeOverride } from '@mantine/core';
import {
  EmbedThemeColors,
  generateColorShades,
} from '../utils/themeFromUrl';

declare module '@mantine/core' {
  export interface MantineThemeOther {
    colors: EmbedThemeColors;
  }
}

export function buildMantineTheme(
  colors: EmbedThemeColors,
): MantineThemeOverride {
  return {
    primaryColor: 'brand',
    primaryShade: 6,
    colors: {
      brand: generateColorShades(colors.primary),
      accent: generateColorShades(colors.accent),
      darkPrimary: generateColorShades(colors.darkPrimary),
    },
    other: {
      colors,
    },
    globalStyles: () => ({
      'html, body, #root': {
        color: colors.text,
      },
      'body': {
        backgroundColor: '#ffffff',
      },
    }),
    components: {
      Button: {
        styles: (_theme, params) => {
          if (params.variant === 'outline') {
            return {
              root: {
                'borderColor': colors.primary,
                'color': colors.primary,
                '&:hover': {
                  backgroundColor: colors.accent,
                  borderColor: colors.primary,
                  color: colors.darkPrimary,
                },
              },
            };
          }
          // Filled / default primary buttons
          return {
            root: {
              'backgroundColor': colors.primary,
              'color': colors.buttonText,
              '&:hover': {
                backgroundColor: colors.darkPrimary,
              },
            },
          };
        },
      },
      MultiSelect: {
        styles: () => ({
          label: {
            color: colors.darkPrimary,
            fontWeight: 700,
          },
          input: {
            'color': colors.text,
            '&:focus-within': {
              borderColor: colors.primary,
            },
          },
        }),
      },
      Select: {
        styles: () => ({
          input: {
            'color': colors.text,
            '&:focus': {
              borderColor: colors.primary,
            },
          },
        }),
      },
      List: {
        styles: () => ({
          itemWrapper: {
            color: colors.text,
          },
        }),
      },
      Text: {
        styles: () => ({
          root: {
            color: colors.text,
          },
        }),
      },
    },
  };
}
